export default Object.freeze({
  "PENDING_SYNC": "PSY",
  "STOCK": "STO",
  "CANCELED": "CAS",
  "ON_SUBSCRIPTION": "ONS", 
});

